import { memo, type ReactNode } from 'react';
import isEqual from 'react-fast-compare';
import { WindowVirtualizer, type WindowVirtualizerHandle } from 'virtua';

const Container = memo(
  ({
    children,
    onRef,
    onScroll,
    onScrollEnd,
  }: // onDayTitleIndexChange,
  {
    children: ReactNode;
    onRef: React.LegacyRef<WindowVirtualizerHandle>;
    onScroll: () => void;
    onScrollEnd: () => void;
    // onDayTitleIndexChange: (result: Record<string, number>) => void;
  }) => {
    // useDebounceEffect(
    // 	() => {
    // 		const list = Children.toArray(children);
    // 		let index = 0;
    // 		const result: Record<string, number> = {};

    // 		for (const element of list) {
    // 			if (typeof element === "object") {
    // 				if (
    // 					(element as unknown as { type: typeof DayTitle }).type ===
    // 					DayTitle
    // 				) {
    // 					result[(element as { props: { date: string } }).props.date] =
    // 						index;
    // 				}
    // 			}

    // 			index += 1;
    // 		}

    // 		onDayTitleIndexChange(result);
    // 	},
    // 	[children],
    // 	{ wait: 200 },
    // );

    return (
      <div className='bg-white min-h-screen'>
        <WindowVirtualizer
          onScroll={onScroll}
          onScrollEnd={onScrollEnd}
          ref={onRef}
        >
          {children}
        </WindowVirtualizer>
      </div>
    );
  },
  isEqual
);

export default Container;
